import { httpgst, http } from '../../main'
import { store } from '../../store'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get_approvers ({commit, dispatch}, payload) {
    let url = 'api/approvers'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('approverGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // Set a new current approver
  setCurrentApprover ({ commit, dispatch }, payload) {
    let url = 'api/approvers'
    let params = {
      'user_id': payload.event.item.user_id,
      'is_default': payload.event.item.is_default
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('approverPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        })
  },
  put_approvers ({commit, dispatch}, payload) {
    let url = 'api/approvers/' + payload.event.item.id
    let params = {
      'is_default': payload.event.item.is_default
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {})
      .then(
        response => {
          commit('approverPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  // Remove the current  approver
  removeCurrentApprover ({ commit, dispatch }, payload) {
    let url = 'api/approvers/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('approverDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        })
  },
  get_users ({commit, dispatch}, payload) {
    let url = 'api/user'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('userGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {

  approverGet (state, payload) {
    payload.event.context.approvers = payload.response.data.data
    payload.event.context.loadingItems = false
  },
  // Set the context values for new current approver and shows a notification
  approverPost (state, payload) {
    // let approver = payload.response.data.data
    // approver.user_id = approver.user_id
    // let approvers = payload.event.context.approvers
    // approvers.push(approver)
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  approverPut (state, payload) {
    // let approver = payload.response.data.data
    // approver.user_id = approver.user_id
    // let approvers = payload.event.context.approvers
    // approvers.splice(payload.event.index, 1, approver)
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  // Set the context values for removing current approver and shows a notification
  approverDelete (state, payload) {
    let approvers = payload.event.context.approvers
    approvers.splice(payload.event.index, 1)
    payload.event.context.removeDisabled = false
    payload.event.context.confirmRemoveDisabled = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeRemove()
    payload.event.context.refresh()
  },
  userGet (state, payload) {
    payload.event.context.users = payload.response.data.data
  },
  // Shows a error message
  onError (state, payload) {
    // payload.event.context.setMessage(payload.error.response.data.message)
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/approver.js